<template>
  <div class="page">
    <div class="left">
      <div class="sticky">
        <div class="calendar">
          <div class="header">
            <a><a-icon type="left" @click="changeMonth(-1)" /></a>
            <div>{{ year }}年{{ month }}月</div>
            <a><a-icon type="right" @click="changeMonth(1)" /></a>
          </div>
          <div class="weekdays">
            <div v-for="day in weekdays" :key="day" class="weekday">{{ day }}</div>
          </div>
          <div class="days">
            <div v-for="(day, index) in days" :key="index" class="day" :class="{
              'other-month': isOtherMonth(index),
              'disabled': isOtherMonth(index),
              'selected': isSelected(day, index)
            }" @click="chooseDay(day)">
              <span class="today" v-if="isToday(day, index)">今日</span>
              <span>{{ day || '' }}</span>
            </div>
          </div>
        </div>
        <!-- <div class="mini">
        <div class="mini-title">运营端小程序</div>
        <div class="pic">
          <img src="../../../public/portal/mini program.png" alt="">
        </div>
      </div> -->
      </div>
    </div>
    <div class="right">
      <div class="date">
        {{ day }} 星期{{ weekday }}
        <div class="dfc">
          <a-button class="mr24" @click="printDailySchedule">打印课表 <a-icon type="right-circle" /></a-button>
          <a-button @click="openDrawer">查看日报 <a-icon type="right-circle" /></a-button>
        </div>
      </div>
      <div class="df">
        <div class="today box1">
          <div class="title">当日</div>
          <div class="body">
            <div class="total">
              <div class="flex1">
                <div class="pic">
                  <img src="/index/icon10.png" />
                </div>
                <div class="number">
                  {{ classData.totalClassCount || 0 }}
                  <p>开课班级</p>
                </div>
              </div>
              <div class="flex1">
                <div class="pic">
                  <img src="/index/icon4.png" />
                </div>
                <div class="number">
                  {{ studentData.totalStudent || 0 }}
                  <p>应出勤学生</p>
                </div>
              </div>
            </div>
            <div class="jcsb">
              <div class="detail">
                <div class="logo1">
                  <img src="/index/icon5.png" />
                </div>
                <div class="label"><b>作业托管</b></div>
                <div class="count">{{ classData.trustClassCount || 0 }}</div>
                <div>开课班级</div>
                <div class="count">{{ studentData.trustStudentCount || 0 }}</div>
                <div>参与学员</div>
              </div>
              <div class="detail m16">
                <div class="logo1">
                  <img src="/index/icon6.png" />
                </div>
                <div class="label"><b>学校社团</b></div>
                <div class="count">{{ classData.corClassCount || 0 }}</div>
                <div>开课班级</div>
                <div class="count">{{ studentData.corStudentCount || 0 }}</div>
                <div>参与学员</div>
              </div>
              <div class="detail">
                <div class="logo1">
                  <img src="/index/icon7.png" />
                </div>
                <div class="label"><b>特色课程</b></div>
                <div class="count">{{ classData.perClassCount || 0 }}</div>
                <div>开课班级</div>
                <div class="count">{{ studentData.perStudentCount || 0 }}</div>
                <div>参与学员</div>
              </div>
            </div>
          </div>
        </div>
        <div class="oper box1">
          <div class="title">运营</div>
          <div class="body">
            <div class="blue">
              值班老师
            </div>
            <div class="df mb16">
              <div class="box2" v-for="item in dutyTeacherList" :key="item.operUserId">
                <div class="pic" v-if="item.imgUrl">
                  <img :src="item.imgUrl" />
                </div>
                <div class="pic-round" v-else :style="{ backgroundColor: item.avatarBgColor }">
                  {{ item.firstWord }}
                </div>
                <div class="name">
                  {{ item.nickname }}
                  <p>值班老师</p>
                </div>
              </div>
            </div>
            <div class="empty" v-if="!dutyTeacherList.length">
              <a-empty description="暂无值班老师"></a-empty>
            </div>
            <div class="blue">
              驻校运营老师
            </div>
            <div class="box2 w100 dfsb" v-for="item in operTeacherList" :key="item.operUserId">
              <div class="df">
                <div class="pic" v-if="item.imgUrl">
                  <img :src="item.imgUrl" />
                </div>
                <div class="pic-round" v-else :style="{ backgroundColor: item.avatarBgColor }">
                  {{ item.firstWord }}
                </div>
                <div class="name">
                  {{ item.operUserName }}
                  <p>值班老师</p>
                </div>
              </div>
              <div class="sign" v-if="item.checkinStatus !== 0">
                <img src="../../../public/home/signed.png">
                {{ item.checkinTime }}签到
              </div>
              <div class="sign" v-else>
                <img src="../../../public/home/unsign.png">
                未签到
              </div>
              <div class="sign" v-if="item.checkoutStatus !== 0">
                <img src="../../../public/home/signed.png">
                {{ item.checkoutTime }}签退
              </div>
              <div class="sign" v-else>
                <img src="../../../public/home/unsign.png">
                未签退
              </div>
            </div>
            <div class="empty" v-if="!operTeacherList.length">
              <a-empty description="暂无运营老师"></a-empty>
            </div>
          </div>
        </div>
      </div>
      <div class="class-list">
        <b>班级清单</b>
        <div class="options">
          <a-button type="link" class="option" v-for="item in courseTypeArr" :key="item.value"
            :class="{ 'active': courseTypeList.includes(item.value) }" @click="chooseCourseType(item.value)">
            {{ item.label }}
          </a-button>
        </div>
        <div class="class-box" v-if="classList.length">
          <div class="class-item" v-for="item in classList" :key="item.id">
            <div class="info">
              <div class="dfc">
                <div class="tag" :class="item.classifyId == 1 ? 'tag1' : item.classifyId == 2 ? 'tag2' : 'tag3'">{{
                  item.classifyId == 1 ? '特色' : item.classifyId == 2 ? '社团' : '托管' }}</div>
                <div class="name">{{ item.className }}</div>
                <div class="id">课程ID：{{ item.id }}</div>
              </div>
              <div class="status">
                <div class="mr16" :class="{ 'status-check' : item.teacherCheckin.length }">
                  <a-icon :type="item.teacherCheckin.length ? 'check-circle' : 'exclamation-circle'" style="font-size: 24px;margin-bottom: 4px;"/>
                  <p>考勤</p>
                </div>
                <div :class="{ 'status-check' : item.teacherEvaluationCount }">
                  <a-icon :type="item.teacherEvaluationCount ? 'check-circle' : 'exclamation-circle'" style="font-size: 24px;margin-bottom: 4px;"/>
                  <p>评价</p>
                </div>
              </div>
              <div class="time">
                <a-icon type="clock-circle" /> {{ item.classTime }}
                <span class="ml36" v-if="item.placeName"><a-icon type="environment" /> {{ item.placeName }}</span>
              </div>
              <div v-if="item.content" class="content-box fz12">
                <div class="pic" v-if="item.teacherId">
                  <img :src="item.imgUrl" v-if="item.imgUrl" />
                  <div class="pic-round" v-else :style="{ backgroundColor: item.avatarBgColor }">
                    {{ item.firstWord }}
                  </div>
                </div>
                <div v-else>
                  <a-icon type="user" />
                </div>
                <div style="flex: 1;" :class="{ 'pt-12': item.teacherId, 'ml6': !item.teacherId }">
                  <div class="lh26">{{ item.teacherName ? item.teacherName + ',' : '未设置' }}主讲老师</div>
                  <div class="content">
                    <img src="../../../public/portal/content.png" style="border-radius: 0;" />
                    <div class="ml6">
                      <div class="mb8">{{ '本次为第' + item.classPeriodNum + '节课，共计' + item.classHours + '节。' }}</div>
                      <div class="content-text">{{ item.title }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="df fz12" v-else>
                <a-icon type="user" style="transform: translateY(2px);" />
                <span class="ml6">{{ item.teacherName ? item.teacherName + ',' : '未设置' }}主讲老师</span>
              </div>
            </div>
            <div class="checkin">
              <div>
                <div class="dfc" v-if="item.teacherCheckin.length">
                  <div class="dfc" v-for="(item2, index) in item.teacherCheckin" :key="index">
                    <img :src="item2.headImgUrl" v-if="item2.headImgUrl && index < 3"
                      :class="{ 'ml-18': item.teacherCheckin.length > 1 && index !== 0 }" />
                    <div class="pic-round" :class="{ 'ml-18': item.teacherCheckin.length > 1 && index !== 0 }"
                      v-if="!item2.headImgUrl && index < 3" :style="{ backgroundColor: item2.avatarBgColor }">
                      {{ item2.firstWord }}
                    </div>
                  </div>
                  <span v-if="item.teacherCheckin.length > 1">
                    {{ item.teacherCheckin[0].checkinTeacherName + '、' + item.teacherCheckin[1].checkinTeacherName
                    }}{{ item.teacherCheckin.length > 2 ? '等' : '' }}{{ item.teacherCheckin.length }}位老师已考勤
                  </span>
                  <span v-else>{{ item.teacherCheckin[0].checkinTeacherName + '已在' +
                    item.teacherCheckin[0].teacherCheckinTime + '分考勤' }}</span>
                </div>
              </div>
              <router-link :to="`/classDetail?id=${item.classId}&courseId=${item.courseId}`">查看<a-icon type="right" />
              </router-link>
            </div>
          </div>
        </div>
        <div class="empty" v-else>
          <a-empty></a-empty>
        </div>
      </div>
    </div>
    <operationDetail v-if="showDetail" :showDetail.sync="showDetail" :attendDate="day">
    </operationDetail>
  </div>
</template>

<script>
import education from "../../api/education";
import avatarBgColor from "../../api/avatarBgColor";
import operationDetail from "../education/components/operationDetail.vue";
import synopsis from '../../api/synopsis.js'
import requestHeader from '../../utils/requestHeader'
import dayjs from 'dayjs';
import globalConfig from '../../config/globle.config'
import axios from "axios";
export default {
  data() {
    return {
      courseTypeArr: [{ label: '全部', value: 0 }, { label: '作业托管', value: 3 }, { label: '社团课', value: 2 }, { label: '特色课', value: 1 }],
      showDetail: false,
      dutyTeacherList: [],
      operTeacherList: [],
      courseTypeList: [0],
      classList: [],
      classData: {},
      studentData: {},
      year: '',
      month: '',
      day: '',
      weekday: '',
      weekdays: ['一', '二', '三', '四', '五', '六', '日'],
      days: [],

    }
  },
  components: {
    operationDetail,
  },
  created() {
    this.initTime()
  },
  methods: {
    initTime() {
      this.year = dayjs(new Date).format('YYYY')
      this.month = dayjs(new Date).format('M')
      this.day = dayjs(new Date).format('YYYY-MM-DD')
      let weekday = dayjs(new Date).format('d')
      this.weekday = weekday == 1 ? '一' : weekday == 2 ? '二' : weekday == 3 ? '三' : weekday == 4 ? '四' : weekday == 5 ? '五' : weekday == 6 ? '六' : '日'
      this.getData()
      this.generateDays()
    },
    generateDays() {
      const date = new Date(this.year, this.month - 1, 1); // 当前月份的第一天
      const daysInMonth = new Date(this.year, this.month, 0).getDate(); // 当前月份的总天数
      const firstDayOfWeek = date.getDay(); // 当前月份的第一天是星期几（0=周日, 1=周一, ..., 6=周六）
      // 计算需要补全的上个月日期
      const prevMonthDays = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1; // 如果第一天是周日，补全6天；否则补全 firstDayOfWeek - 1 天
      const prevMonthLastDay = new Date(this.year, this.month - 1, 0).getDate(); // 上个月的最后一天
      const prevMonthDates = Array.from({ length: prevMonthDays }, (_, i) => prevMonthLastDay - prevMonthDays + i + 1);
      // 当前月份的日期
      const currentMonthDates = Array.from({ length: daysInMonth }, (_, i) => i + 1);

      // 计算需要补全的下个月日期
      const totalDays = 42; // 6行 * 7天
      const nextMonthDays = totalDays - (prevMonthDates.length + currentMonthDates.length);
      const nextMonthDates = Array.from({ length: nextMonthDays }, (_, i) => i + 1);

      // 合并所有日期
      this.days = [...prevMonthDates, ...currentMonthDates, ...nextMonthDates];
    },
    isOtherMonth(index) {
      // 判断日期是否属于当前月份
      const date = new Date(this.year, this.month - 1, 1);
      const firstDayOfWeek = date.getDay();
      const prevMonthDays = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;

      // 如果 index 小于 prevMonthDays 或大于等于 prevMonthDays + 当前月份的天数，则属于其他月份
      return index < prevMonthDays || index >= prevMonthDays + new Date(this.year, this.month, 0).getDate();
    },
    isSelected(day, index) {
      if (this.isOtherMonth(index)) return false;
      const currentDate = dayjs(new Date(this.year, this.month - 1, day)).format('YYYY-MM-DD');
      return currentDate === this.day;
    },
    isToday(day, index) {
      if (this.isOtherMonth(index)) return false;
      const currentDate = dayjs(new Date(this.year, this.month - 1, day)).format('YYYY-MM-DD');
      return currentDate === dayjs(new Date).format('YYYY-MM-DD');
    },
    chooseDay(day) {
      let temp = dayjs(new Date(this.year, this.month - 1, day)).format('YYYY-MM-DD')
      if (temp == this.day) return
      this.day = temp
      let weekday = dayjs(new Date(this.year, this.month - 1, day)).format('d')
      this.weekday = weekday == 1 ? '一' : weekday == 2 ? '二' : weekday == 3 ? '三' : weekday == 4 ? '四' : weekday == 5 ? '五' : weekday == 6 ? '六' : '日'
      this.getData()
    },
    chooseCourseType(type) {
      if (type == 0) {
        this.courseTypeList = [0]
        this.getData([1, 2, 3])
        return
      }
      if (this.courseTypeList.includes(type)) {
        if (this.courseTypeList.length > 1) this.courseTypeList.splice(this.courseTypeList.indexOf(type), 1)
      } else {
        this.courseTypeList.push(type)
      }
      if (!this.courseTypeList.every(item => item == 0)) {
        this.courseTypeList = this.courseTypeList.filter(item => item != 0)
      }
      this.getData(this.courseTypeList)
    },
    getData(typeList) {
      let headers = requestHeader.createHeaders()
      headers['Content-Type'] = 'application/json'
      axios.post(
        globalConfig.rootUrl + `/api/pcWeb/teaTermOverview/todayTeachingInfo?time=${this.day}`,
        typeList,
        { headers }
      ).then(res => {
        const data = res.data.data
        this.classData = data.scheduleOperClassCountDTO ? data.scheduleOperClassCountDTO : {}
        this.studentData = data.scheduleOperStudentCountDTO ? data.scheduleOperStudentCountDTO : {}
        this.dutyTeacherList = data.schedulingDutyTeacherDTOList || []
        this.dutyTeacherList.forEach(item => {
          item.firstWord = item.nickname.substring(0, 1)
          item.avatarBgColor = avatarBgColor(item.operUserId)
        })

        this.operTeacherList = data.checkinDTOList || []
        this.operTeacherList.forEach(item => {
          if (!item.imgUrl) {
            item.firstWord = item.operUserName.substring(0, 1)
            item.avatarBgColor = avatarBgColor(item.operUserId)
          }
          if (item.checkinStatus !== 0) {
            item.checkinTime = dayjs(item.checkinTime).format('HH:mm:ss')
          }
          if (item.checkoutStatus !== 0) {
            item.checkoutTime = dayjs(item.checkoutTime).format('HH:mm:ss')
          }
        })
        this.classList = data.teaScheduleDTOList || []
        this.classList.forEach(item => {
          if (!item.imgUrl && item.teacherId) {
            item.firstWord = item.teacherName.substring(0, 1)
            item.avatarBgColor = avatarBgColor(item.teacherId)
          }
          item.teacherCheckin.forEach(item2 => {
            item2.teacherCheckinTime = dayjs(item2.teacherCheckinTime).format('HH:mm')
            if (!item2.headImgUrl) {
              item2.firstWord = item2.checkinTeacherName.substring(0, 1)
              item2.avatarBgColor = avatarBgColor(item2.userId)
            }
          })
        })
      })
    },
    //打印课表
    printDailySchedule() {
      education.printDailySchedule(this.day).then((res) => {
        window.open(globalConfig.rootUrl + res.openPage);
      });
    },
    openDrawer() {
      this.showDetail = true
    },
    changeMonth(num) {
      if (num == 1) {
        this.month++
        if (this.month > 12) {
          this.month = 1
          this.year++
        }
      } else {
        this.month--
        if (this.month < 1) {
          this.month = 12
          this.year--
        }
      }
      this.generateDays()
    },
  }
}
</script>

<style lang="less" scoped>
.page {
  margin: 20px;
  display: flex;
  font-family: Source Han Sans;
}

.left {
  width: 350px;
  margin-right: 16px;
}

.sticky {
  position: sticky;
  top: 20px;
  left: 0;
}

.calendar {
  background-color: #fff;
  width: 350px;
  border-radius: 4px;
  padding: 20px;
  outline: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .15);

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f8f8f8;
    padding: 8px 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 4px;

    a {
      color: #808080;
    }
  }

  .weekdays {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
    margin: 15px 0 10px;
    text-align: center;
  }

  .days {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
    text-align: center;
  }

  .day {
    position: relative;
    width: 40px;
    text-align: center;
    padding: 3px 5px;
    height: 54px;
    line-height: 48px;
    border: 1px solid transparent;
    cursor: pointer;
    border-radius: 4px;
    color: #333;
    font-weight: 500;

    .today {
      position: absolute;
      font-size: 10px;
      line-height: 10px;
      color: #999;
      width: 40px;
      top: 6px;
      left: -2px;
    }
  }

  .day.disabled {
    pointer-events: none;
    background-color: #fff;
    /* 禁用点击事件 */
  }

  .day:hover {
    background-color: #e6f7ff;
    color: #333;
    border: 1px solid #e6f7ff;

    .today {
      color: #999;
    }
  }

  .other-month {
    color: #ccc;
  }

  .selected {
    color: #fff !important;
    background-color: #1677ff !important;
    border: 1px solid #1677ff !important;

    .today {
      color: #fff !important;
    }
  }
}

.right {
  flex: 1;
  padding: 24px;
  background-color: #fff;
  border-radius: 4px;
}

.mr24 {
  margin-right: 24px;
}

.df {
  display: flex;
}

.date {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  color: #3D3D3D;
  font-size: 24px;
  font-weight: bold;

  button {
    color: #249CFF;
    border: #249CFF solid 1px;
  }
}

.today {
  max-width: 564px;
  margin-right: 16px;
}

.box1 {
  flex: 1;
  border: 1px solid #F2F2F2;
  border-radius: 8px;

  .title {
    padding: 11px 20px;
    color: #3D3D3D;
    font-size: 18px;
    line-height: 26px;
    font-weight: bold;
    border-radius: 8px 8px 0px 0px;
    background: linear-gradient(88deg, #D3E6FF 1%, #B1F5FF 99%);
  }

  .body {
    padding: 24px;
  }

  .number {
    padding: 0 16px 0 24px;
    font-size: 32px;
    font-weight: bold;
    color: #3D3D3D;

    p {
      font-size: 14px;
      color: #181920;
      font-weight: normal;
    }
  }
}

.total {
  display: flex;
  border: 1px solid #F2F2F2;
  border-radius: 8px;
  padding: 24px;
  min-width: 412px;
  margin-bottom: 18px;

  .pic {
    width: 70px;
    height: 70px;
  }
}

.flex1 {
  display: flex;
  flex: 1;
}

img {
  width: 100%;
  height: 100%;
}

.jcsb {
  display: flex;
  justify-content: space-between;
}

.detail {
  flex: 1;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #F0F2F5;
  font-size: 14px;

  .logo1 {
    width: 32px;
    height: 32px;
  }

  .label {
    margin: 10px 0 12px;
  }

  .count {
    font-size: 20px;
    line-height: 22px;
    margin: 12px 0 5px;
    font-weight: bold;
  }
}

.m16 {
  margin: 0 16px;
}

.mb16 {
  margin-bottom: 16px;
}

.blue {
  color: #00AEFF;
  font-weight: bold;
  margin-bottom: 16px;
}

.box2 {
  display: flex;
  font-size: 18px;
  border: 1px solid #F2F2F2;
  border-radius: 8px;
  padding: 20px 16px;
  min-width: 170px;
  margin-right: 16px;
  max-width: 33%;
  flex: 1;
  color: #747579;

  .pic {
    min-width: 48px;
    width: 48px;
    height: 48px;
    margin-right: 16px;

    img {
      min-width: 48px;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .pic-round {
    width: 48px;
    min-width: 48px;
    height: 48px;
    border-radius: 50%;
    text-align: center;
    line-height: 48px;
    margin-right: 16px;
    font-size: 24px;
    font-weight: bold;
    background-color: #a7e5cb;
    color: #fff;
  }

  .name {
    color: #181920;

    p {
      margin-top: 4px;
      color: #747579;
      font-size: 14px;
    }
  }

  .sign {
    margin-left: 20px;
    font-size: 14px;
    min-width: 120px;
    text-align: center;

    img {
      width: 28px;
      height: 28px;
      margin-right: 5px;
    }
  }
}

.box2:last-child {
  margin-right: 0;
}

.w100 {
  margin-top: 12px;
  min-width: 480px;
  max-width: 100%;
  padding-right: 40px;
  margin-right: 0;
}

.dfsb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dfc {
  display: flex;
  align-items: center;
}

.mini {
  border-radius: 4px;
  text-align: center;
  background: pink;
  margin-top: 20px;
  padding: 40px 52px;

  .mini-title {
    color: #249CFF;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 40px;
  }

  .pic {
    padding: 30px;
    background-color: #fff;
    border-radius: 20px;
  }
}

.class-list {
  margin-top: 24px;

}

.options {
  display: flex;
  margin: 12px 0 24px;

  .option {
    border: 1px solid #EFEFEF;
    border-radius: 20px;
    font-size: 14px;
    height: 38px;
    line-height: 16px;
    padding: 9px 24px;
    margin-right: 16px;
    color: #3D3D3D;
  }

  .active {
    background-color: #249CFF;
    border: 1px solid #249CFF;
    color: #fff;
  }
}
.mr16 {
  margin-right: 16px;
}
.class-box {
  column-count: 2;
  column-gap: 24px;

  .class-item {
    break-inside: avoid;
    margin-bottom: 16px;
    width: 100%;
    border: 1px solid #F2F2F2;
    border-radius: 8px;
    position: relative;
    .status {
      position: absolute;
      display: flex;
      top: 31px;
      right: 24px;
      color: #979797;
      font-size: 12px;
      p {
        margin-top: 14px;
      }
    }
    .status-check {
      color: #4CBF3A;
    }
    .info {
      padding: 16px 24px;
      border-bottom: 1px solid #F2F2F2;

      .tag {
        padding: 3px 10px;
        font-size: 14px;
        width: 48px;
        margin-right: 10px;
        border-radius: 4px;
        line-height: 14px;
        font-weight: normal;
      }

      .tag1 {
        background-color: #e6f3ff;
        color: #63B2FF;
      }

      .tag2 {
        background-color: #fff1dd;
        color: #FFA320;
      }

      .tag3 {
        background-color: #ddfcf9;
        color: #4DD2C6;
      }

      .name {
        color: #3D3D3D;
        margin-right: 12px;
        font-weight: 500;
      }

      .id {
        color: #979797;
        font-size: 12px;
      }
    }

    .time {
      margin: 16px 0 6px;
      color: #3C454C;
      font-size: 12px;

      i {
        margin-right: 3px;
      }
    }
  }
}

.ml36 {
  margin-left: 36px;
}

.checkin {
  padding: 10px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // height: 46px;
  a {
    font-size: 14px;
    color: #181920;
  }

  span {
    color: #3c454c;
    font-size: 12px;
  }

}

.ml-18 {
  margin-left: -18px;
}

.pt-6 {
  padding-top: 6px;
}

.checkin,
.content-box {

  img {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    margin-right: 7px;
    border: 1px solid #fff;
  }

  .pic-round {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    line-height: 24px;
    margin-right: 7px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    font-weight: bold;
    border: 1px solid #fff;
  }
}

.content-box {
  display: flex;

  .content {
    flex: 1;
    border: 1px solid #D8D8D8;
    border-radius: 4px;
    display: flex;
    padding: 8px 9px;
    color: #979797;

    img {
      width: 18px;
      height: 19px;
    }

    .content-text {
      white-space: pre-wrap;
    }
  }
}

.fz12 {
  color: #3C454C;
  font-size: 12px;
}

.lh26 {
  line-height: 26px;
}

.ml6 {
  margin-left: 6px;
}

.empty {
  padding: 20px;
}

@media screen and (max-width: 1600px) {
  .page {
    zoom: 0.8;
  }
}
</style>